export default __webpack_public_path__ + "static/media/android.8900e368.svg";